import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  currentOrganizationSelector,
  userSelector,
} from "../../store/selectors";
import { updateProject } from "../../store/projectsSlice";
import "./EditProjectModal.css";

const EditProjectModal = ({
  onClose = () => {},
  onRenamed = () => {},
  project,
  currentProject,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector(userSelector);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [projectName, setProjectName] = useState(project?.title || "");
  const [description, setDescription] = useState(project?.description || "");
  const [coverImage, setCoverImage] = useState(null);
  const [coverImageObjectUrl, setCoverImageObjectUrl] = useState(null);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    const keyDownHandler = (e) => {
      handleKeyDown(e);
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("keydown", keyDownHandler);
    };
  }, [onClose, projectName]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    } else if (e.key === "Escape") {
      e.preventDefault();
      onClose();
    }
  };

  const handleSubmit = () => {
    setIsLoading(true);
    let formData = new FormData();
    let projectData = {
      title: projectName,
      description,
      organizationId: currentOrganization.id,
    };
    formData.append("body", JSON.stringify(projectData));

    if (coverImage) {
      formData.append("file", coverImage);
    }

    dispatch(updateProject({ id: project.id, projectData: formData }))
      .then((res) => {
        setIsLoading(false);
        if (!res.error) {
          onRenamed(res.payload);
          onClose();
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 20 * 1024 * 1024) {
      // 20MB limit
      setCoverImageObjectUrl(URL.createObjectURL(file));
      setCoverImage(file);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-editproj" ref={modalRef}>
        <button className="edit-project-close-button" onClick={onClose} />
        <h1 className="edit-project-modal-title">Переименовать папку</h1>
        <div className="edit-project-modal-content">
          <input
            className="edit-project-project-input"
            placeholder="Название проекта"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
          />
        </div>

        <button
          onClick={handleSubmit}
          className="edit-project-submit-button"
          disabled={isLoading}
        >
          {isLoading ? "Загрузка..." : "Сохранить"}
        </button>
      </div>
    </div>
  );
};

export default EditProjectModal;
